

(function footerDirectiveDefinition() {

    angular.module('ui.Layout')
           .directive('footer', ['config', '$document', function footerDirectiveFactory(config, $document) {

               return {
                   templateUrl: config.resourceUrl('/components/ui/layout/footer.html'),
                   transclude: true,
                   restrict: 'E',
                   controller: ['$scope', '$element', '$attrs',
                       function footerController($scope, $element, $attrs) {

                           //global function to scroll page up
                           this.toTheTop = function () {
                               $document.scrollTopAnimated(0, 600);
                           };

                       }],
                   controllerAs: 'footer'
               };

           }]);

})();